module.exports = __webpack_public_path__ + "static/media/grph-stat2-66.1d1f505f.svg";